module.exports = __webpack_public_path__ + "img/bg_topbar.375c5271.png";